import {types} from "mobx-state-tree";

export const userNominated = types.model({
    id : types.integer,
    name: types.string,
    email: types.string,
    image: types.string,
    nominated: types.optional(types.boolean,false),
}).actions(self => ({
    changeNominated(cn_bool){
        self.nominated = cn_bool
    }
}));

export const userNominatedList = types.model({
    users : types.optional(types.array(userNominated),[]),
}).actions(self=>({
    addUsersNominated(newData){
        newData.forEach(item =>{
            self.users.push(item);
        })
    },
    getNominatedUser(id){
        self.users.forEach((user)=>{
            return (user.id==id?user:null);
        })
    }
})).views(self => ({
    numberOfUnnominatedChildren() {
        return self.users.filter(user => user.nominated = false).length
    },
}));